/** Комментарии к проекту или к кадру: список (новые сверху) и поле «оставить». */

import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import { when } from "@/lib/media";
import type { Comment } from "@/lib/project";
import { errorText, postJson } from "@/lib/project";

import { Btn, Empty, ErrorLine, inputClass, Panel } from "./ui";

export function Comments({
  title,
  comments,
  target,
  placeholder,
  onAdded,
}: {
  title: string;
  comments: Comment[];
  target: { project_id: number } | { project_shot_id: number };
  placeholder: string;
  onAdded: () => Promise<unknown> | void;
}) {
  const [text, setText] = useState("");
  const add = useMutation({
    mutationFn: (value: string) => postJson<{ id: number }>("/api/comments", { text: value, ...target }),
    onSuccess: async () => {
      setText("");
      await onAdded();
    },
  });

  return (
    <Panel title={title} annot={title}>
      <div className="grid gap-2">
        {comments.length === 0 ? (
          <Empty>Пока нет.</Empty>
        ) : (
          comments.map((c) => (
            <div key={c.id} className="border-b border-border pb-2 last:border-b-0">
              <div className="whitespace-pre-wrap">{c.comment_text}</div>
              <div className="text-[11.5px] text-fg-faint">
                {c.comment_author} · {when(c.date_create)}
              </div>
            </div>
          ))
        )}
      </div>
      <form
        className="mt-3 flex flex-wrap gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          const value = text.trim();
          if (value && !add.isPending) add.mutate(value);
        }}
      >
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={placeholder}
          required
          className={`${inputClass} min-w-[240px] flex-1`}
        />
        <Btn type="submit" disabled={add.isPending || !text.trim()}>
          Оставить
        </Btn>
      </form>
      <ErrorLine text={add.isError ? errorText(add.error) : ""} className="mt-2" />
    </Panel>
  );
}
